import { Component, Input, ViewEncapsulation } from '@angular/core';
import { PaymentPromoData } from '../payment-promos-model';
import { OscardStaticService } from 'projects/common/services/oscard-static.service';

@Component({
  selector: 'payment-promo-banner',
  template: ` 
    <div class="banner" tabindex="0" [id]='promoData.anchor'>

      <img class="image-section" [src]='getImgSrc()' alt="Imagen del banco" />

      <div class="text-section">
        <div class="eva-3-p -eva-3-bold">{{ promoData.title + ' ' + promoData.subtitle }}</div>
        <div class="description">{{ promoData.legal_text }}</div>
      </div>

      <div class="cft-section">
        <div *ngIf="promoData.cft_text">
          <div class="eva-3-h5 -eva-3-tc-gray-1">CFT:</div>
          <div class="cft-value">{{ promoData.cft_text }}%</div>
        </div>
      </div>

    </div>
  `,
  styleUrls: ['./payment-promo-banners.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PaymentPromoBanner {
  @Input() promoData: PaymentPromoData;

  constructor(private oscardStaticService: OscardStaticService) {
  }

  getImgSrc(): string {
    return this.oscardStaticService.getBankPictureUrl(this.promoData.bank_code);
  }
}
